import { useTranslation } from "react-i18next";
import LabelCustomInputRow from "../../customer/contract/form/LabelCustomInputRow";
import CommonTextField from "../../../common/components/functional/commonTextField/CommonTextField";
import { MultiInputDateTimeRangeField } from "@mui/x-date-pickers-pro/MultiInputDateTimeRangeField/MultiInputDateTimeRangeField";
import { Severity, TargetGroup, TargetGroupType } from "./types";
import {
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Grid,
  RadioGroup,
  Radio,
} from "@mui/material";
import { isValidAnnouncementDateRange } from "./helpers";
import { useFormContext } from "react-hook-form";

export const NewAnnouncementForm = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext();
  const isExistingAnnouncement = !!watch("id");

  const handleTargedGroupCheck = (
    field: {
      value: TargetGroupType[];
      onChange: (value: TargetGroupType[]) => void;
    },
    value: TargetGroupType,
  ) => {
    if (field.value.includes(value)) {
      field.onChange(field.value.filter((v) => v !== value));
    } else {
      field.onChange([...field.value, value]);
    }
  };

  return (
    <Grid container spacing={2}>
      <LabelCustomInputRow
        fieldName="dateRange"
        label={t("common:timePeriod")}
        labelWidth={2}
        inputWidth={10}
        rules={{
          validate: (value: [Date | null, Date | null]) =>
            isValidAnnouncementDateRange(value),
        }}
        render={(field) => (
          <MultiInputDateTimeRangeField
            value={field.value}
            onChange={([start, end]) => {
              field.onChange([start, end]);
            }}
            slotProps={{
              textField: {
                size: "small",
              },
            }}
          />
        )}
      />
      <LabelCustomInputRow
        fieldName="severity"
        label={t("settings:severity")}
        labelWidth={2}
        inputWidth={10}
        render={(field) => (
          <FormControl>
            <RadioGroup value={field.value} onChange={field.onChange} row>
              <FormControlLabel
                control={<Radio value={Severity.Info} />}
                label={t("settings:info")}
              />
              <FormControlLabel
                control={<Radio value={Severity.Warning} />}
                label={t("settings:warning")}
              />
              <FormControlLabel
                control={<Radio value={Severity.Critical} />}
                label={t("settings:critical")}
              />
            </RadioGroup>
          </FormControl>
        )}
      />
      <LabelCustomInputRow
        fieldName="appTypes"
        label={t("settings:targetGroup")}
        labelWidth={2}
        inputWidth={10}
        render={(field) => (
          <FormControl>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={field.value?.includes(TargetGroup.Talent)}
                    disabled={isExistingAnnouncement}
                    value={TargetGroup.Talent}
                    onChange={() =>
                      handleTargedGroupCheck(field, TargetGroup.Talent)
                    }
                  />
                }
                label={t("common:Talent")}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={field.value?.includes(TargetGroup.Customer)}
                    disabled={isExistingAnnouncement}
                    value={TargetGroup.Customer}
                    onChange={() =>
                      handleTargedGroupCheck(field, TargetGroup.Customer)
                    }
                  />
                }
                label={t("common:Customer")}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={field.value?.includes(TargetGroup.Expert)}
                    disabled={isExistingAnnouncement}
                    value={TargetGroup.Expert}
                    onChange={() =>
                      handleTargedGroupCheck(field, TargetGroup.Expert)
                    }
                  />
                }
                label={t("common:Expert")}
              />
            </FormGroup>
          </FormControl>
        )}
      />
      <LabelCustomInputRow
        fieldName="contentFi"
        label={t("settings:contentFi")}
        labelWidth={2}
        inputWidth={10}
        render={(field) => (
          <FormControl fullWidth>
            <CommonTextField
              type="text"
              value={field.value}
              onChange={(e) => field.onChange(e.target.value)}
              multiline
              rows={2}
              inputProps={{ maxLength: 2000 }}
              helperText={`${field.value?.length || 0}/2000`}
            />
          </FormControl>
        )}
      />
      <LabelCustomInputRow
        fieldName="contentEn"
        label={t("settings:contentEn")}
        labelWidth={2}
        inputWidth={10}
        render={(field) => (
          <FormControl fullWidth>
            <CommonTextField
              type="text"
              value={field.value}
              onChange={(e) => field.onChange(e.target.value)}
              multiline
              rows={2}
              inputProps={{ maxLength: 2000 }}
              helperText={`${field.value?.length || 0}/2000`}
            />
          </FormControl>
        )}
      />
    </Grid>
  );
};
